import React, { ReactNode } from 'react';
import Icon from '@ant-design/icons';

import { ReactComponent as SortUpSVG } from '../../assets/sightx-icons/svg/icon-sort-up.svg';
import { ReactComponent as SortDownSVG } from '../../assets/sightx-icons/svg/icon-sort-down.svg';
import { Features } from '../../featureToggles/features/index';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { FeatureToggle, Off, On } from '../../featureToggles/index';

interface Props {
  onSort?: (sort: SortStatus) => void;
  sortUpClassName?: string;
  sortDownClassName?: string;
  noSortClassName?: string;
  containerClassName?: string;
  status?: SortStatus;
}

export enum SortStatus {
  Up = 1,
  Down = -1,
  None
}

export class SortButton extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isSortingDown: false,
      isSortingUp: false
    };
    this.onSort = this.onSort.bind(this);
  }

  onSort():void {
    const { status = SortStatus.None } = this.props;
    const nextStatus = status === SortStatus.None ? SortStatus.Down : status === SortStatus.Down ? SortStatus.Up : SortStatus.None;
    if (this.props.onSort) {
      this.props.onSort(nextStatus);
    }
  }

  renderSortingIcon():ReactNode {
    const { status, sortDownClassName, sortUpClassName, noSortClassName } = this.props;

    if (status === SortStatus.Up) {
      return <FeatureToggle feature={Features.Uirefresh}>
        <Off>
          <Icon
            component={SortUpSVG}
            className={sortUpClassName}
          />
        </Off>
        <On>
          <ArrowUpOutlined className={sortUpClassName} />
        </On>
      </FeatureToggle>;
    }

    if (status === SortStatus.Down) {
      return <FeatureToggle feature={Features.Uirefresh}>
        <Off>
          <Icon
            component={SortDownSVG}
            className={sortDownClassName}
          />
        </Off>
        <On>
          <ArrowDownOutlined className={sortDownClassName} />
        </On>
      </FeatureToggle>;
    }

    return <FeatureToggle feature={Features.Uirefresh}>
      <Off>
        <Icon
          component={SortDownSVG}
          className={noSortClassName}
        />
      </Off>
      <On>
        <ArrowDownOutlined className={noSortClassName} />
      </On>
    </FeatureToggle>;
  }

  render():ReactNode {
    return (
      <div onClick={this.onSort} className={this.props.containerClassName}>
        {this.renderSortingIcon()}
      </div>
    );
  }
}